import { useCallback } from 'react';
import { IoIosTrash } from 'react-icons/io';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useHistory } from 'react-router';
import SyncLoader from 'react-spinners/SyncLoader';
import ReactTooltip from 'react-tooltip';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import Footer from '../../../components/footer-for-scrooling';
import SortButton from '../../../components/sort-desc/SortButton';

const PersonsTable = ({
  persons,
  page,
  setItemDelete,
  params,
  setParams,
  loading,
  setScrolling,
}) => {
  const history = useHistory();

  const changePage = useCallback(() => {
    setScrolling(true);
    setParams((prevState) => ({
      ...prevState,
      current_page: page.current_page + 1,
    }));
  }, [page]);

  const sortPersons = useCallback(
    (field, sort) => {
      setParams((prevState) => ({
        ...prevState,
        sorts: `${field}:${sort}`,
        per_page: persons.length,
      }));
    },
    [persons]
  );

  return (
    <Container>
      <div className="col-12 text-center mt-5">
        <h6>
          TOTAL DE REGISTROS - {persons.length} de <b>{page?.total}</b>
        </h6>
      </div>

      <div className="row mt-3">
        <div className="col">
          <InfiniteScroll
            dataLength={persons.length}
            next={changePage}
            hasMore={page.has_next_page}
            loader={
              <div className="col text-center">
                {loading && (
                  <SyncLoader color="#F7931E" size={15} margin={10} />
                )}
              </div>
            }
            endMessage={
              <div className="col text-center">
                <h6>
                  TOTAL DE REGISTROS - {persons.length} de <b>{page?.total}</b>
                </h6>
              </div>
            }
          >
            <div className="table-responsive">
              <table className="table table-hover text-center">
                <thead>
                  <tr>
                    <th scope="col" className="text-start">
                      ID TROLL
                    </th>
                    <th scope="col" className="text-start">
                      <SortButton
                        label="NOME"
                        params={params}
                        ascFunction={() => sortPersons('full_name', 'ASC')}
                        descFunction={() => sortPersons('full_name', 'DESC')}
                      />
                    </th>
                    <th scope="col">CPF/CNPJ</th>
                    <th scope="col">EMAIL</th>
                    <th scope="col">TELEFONE</th>
                    <th scope="col" className="text-end">
                      AÇÃO
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {persons.map((item) => (
                    <tr
                      key={item.id}
                      onClick={(e) => {
                        if (e.target.innerText !== undefined) {
                          history.push(`persons/${item.id}`);
                        }
                      }}
                    >
                      <td className="text-start">{item.troll_code}</td>
                      <td className="text-start">{item.full_name}</td>
                      <td className="text-CENTER">{item.cpf_cnpj}</td>
                      <td>{item.email}</td>
                      <td>{item.phone_number}</td>

                      <td className="text-end action">
                        <IoIosTrash
                          size={25}
                          className="mb-1"
                          data-tip="Excluir"
                          onClick={() =>
                            setItemDelete({
                              id: item.id,
                              description: item.full_name,
                            })
                          }
                          data-bs-toggle="modal"
                          data-bs-target="#modal-pessoa"
                        />
                        <ReactTooltip />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </InfiniteScroll>
        </div>
      </div>

      <Footer />
    </Container>
  );
};

PersonsTable.propTypes = {
  persons: PropTypes.arrayOf(Object).isRequired,
  page: PropTypes.shape().isRequired,
  setItemDelete: PropTypes.func.isRequired,
  setParams: PropTypes.func.isRequired,
  params: PropTypes.shape().isRequired,
  loading: PropTypes.bool.isRequired,
  setScrolling: PropTypes.func.isRequired,
};

export default PersonsTable;

export const Container = styled.section`
  /* text-transform: uppercase; */

  height: 100vh;

  h6 {
    font-size: 12px;
  }

  .table-hover {
    cursor: pointer;
  }

  .action {
    color: #d11515;

    :hover {
      cursor: pointer;
      color: #ec4646;
    }
  }

  @media screen and (max-width: 768px) {
    .table {
      width: 900px !important;
    }
  }
`;

export const OrderName = styled.div`
  svg {
    margin-left: 8px;
    margin-top: -1px;
    :hover {
      color: #ffba00;
    }
  }
`;
